'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _util = require('../util');

var _util2 = _interopRequireDefault(_util);

var _config = require('../config');

var _config2 = _interopRequireDefault(_config);

var _log = require('../log');

var _keeper = require('../keeper');

var _keeper2 = _interopRequireDefault(_keeper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LBS = function () {
    function LBS() {
        _classCallCheck(this, LBS);

        this.type = 'x5';
        this.keeper = undefined;
    }

    _createClass(LBS, [{
        key: 'supportGeo',
        value: function supportGeo() {
            return (/TBS/i.test(navigator.userAgent) && ~_config2.default.get('enables').indexOf('x5')
            ); // 组件策略：目前只对X5内核开放
        }
    }, {
        key: 'process',
        value: function process(succ, fail, next) {
            var _this = this;

            var opt = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

            // 预处理
            typeof succ == 'function' || (succ = this.noop);
            typeof fail == 'function' || (fail = this.noop);
            typeof next == 'function' || (next = this.noop);

            if (!this.supportGeo()) return next();
            opt.trigger = function (token) {
                // API超时
                fail({
                    code: 408,
                    message: _this.type + ' API Timeout:' + opt.timeout,
                    type: _this.type
                }, token);
            };
            this.keeper = new _keeper2.default(opt);

            _util2.default.loadScript('//apis.map.qq.com/tools/geolocation/min?key=6ULBZ-4X3C3-QEK3S-3ZRI6-6D7RE-WQFRQ&referer=大众点评M站', function () {
                try {
                    var x5Geo = new qq.maps.Geolocation('6ULBZ-4X3C3-QEK3S-3ZRI6-6D7RE-WQFRQ', '大众点评M站');
                    x5Geo.getLocation(function (location) {
                        succ({
                            lat: location.lat,
                            lng: location.lng,
                            geoType: 'gcj02', // 坐标系类型
                            type: _this.type
                        }, _this.keeper.getToken());
                    }, function () {
                        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                        fail({
                            code: 404, // 可选的定位方式，特殊状态码
                            message: e.message || JSON.stringify(e),
                            type: _this.type
                        }, _this.keeper.getToken());
                    }, {
                        timeout: opt.timeout
                    });
                } catch (e) {
                    // 同步异常
                    fail({
                        code: 400,
                        message: e && e.message || JSON.stringify(e),
                        type: _this.type
                    }, _this.keeper.getToken());
                }
            });
        }
    }, {
        key: 'noop',
        value: function noop() {}
    }]);

    return LBS;
}();

var instance = new LBS();
module.exports = instance.process.bind(instance);
module.exports.type = instance.type;


//////////////////
// WEBPACK FOOTER
// ./~/@dp/whereami/lib/geos/x5.js
// module id = 249
// module chunks = 0